import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollToTop(props) {
  useEffect(() => {
    if (props.location.pathname) {
      window.scrollTo(0, 0);
    }
  }, [props.location.pathname]);

  return props.children;
}
export default withRouter(ScrollToTop);
